// Module
var code = "<div class=\"layout-column layout-fill flex md-padding\">\r\n    <mn-files ng-if=\"vm.show\" mn-scroll-item=\"files\" root=\"patient\"\r\n              root-id=\"vm.currentPatient\" class=\"full-height\"\r\n              context=\"vm.context\" extra-context=\"vm.extraContext\">\r\n    </mn-files>\r\n</div>";
// Exports
module.exports = code;